import React, { useContext, useState } from "react";
import {
  StyledHeaderWrapper,
  MenuOverlay,
  MenuContent,
  MenuSection,
  MenuButton,
  AppStoreButton,
  MenuHeader,
  MenuBody,
  CloseButton,
  AppStoreLinks,
  LinkContainer,
  AdditionalLinks,
} from "./styled";
import BILogo from "../../../img/bi_logo.png";
import { Button, Grid, Typography, Link, SvgIcon } from "@mui/material";
import { AuthContext } from "../../../context/authContext";
import {
  LogoutOutlined,
  Person,
  Close,
  Facebook,
  LinkedIn,
  Twitter,
  Phone,
  Email,
} from "@mui/icons-material";
import { colors } from "../../../theme/colors";
import { jwtDecode } from "jwt-decode";
import BIButton from "../Button";
import { useNavigate } from "react-router-dom";

import { ReactComponent as AppstoreLogo } from "../../../img/svg/app-store.svg";
import { ReactComponent as PlayStoreLogo } from "../../../img/svg/google-play.svg";

import { ReactComponent as XLogo } from "../../../img/svg/bi-icons-x.svg";
import { ReactComponent as linkedinLogo } from "../../../img/svg/linkedin-in.svg";

import WordPressFeaturedPosts from "../../common/WordpressPost/HeaderPost";

export default function Header() {
  const { idCliente, logout } = useContext(AuthContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigate = useNavigate();

  const logOut = () => {
    fetch(`${process.env.REACT_APP_BE_URL}/auth/logout`, {
      credentials: "include",
    }).then(() => logout());
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const capitalizeName = (name) => {
    if (!name) return "";

    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getUserData = () => {
    if (!idCliente) return null;

    try {
      const token = localStorage.getItem("authToken");
      if (token) {
        const decodedToken = jwtDecode(token);
        return {
          name: decodedToken.PrimerNombre || "Usuario",
          givenName: capitalizeName(decodedToken.PrimerNombre) || "",
          corp: decodedToken.Corp || decodedToken.nit || "",
          idCliente: decodedToken.IdCliente,
        };
      }
    } catch (error) {
      console.error("Error parsing token from localStorage:", error);
    }

    return {
      name: "Usuario",
      givenName: "",
      corp: "",
      idCliente: idCliente,
    };
  };

  const userData = getUserData();
  const isLoggedIn = !!idCliente;

  if (isLoggedIn) {
    return (
      <>
        <StyledHeaderWrapper>
          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            style={{ height: "100%", width: "95%", margin: "0 auto" }}
          >
            <Grid item>
              <Typography
                variant="h6"
                sx={{
                  color: colors.primary,
                  fontWeight: 600,
                  fontSize: "1.2rem",
                }}
              >
                Retos Banco Industrial
              </Typography>
            </Grid>

            <Grid item>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <Typography
                    sx={{ color: colors.gray.textLight, paddingRight: "1rem" }}
                  >
                    {userData.givenName && (
                      <>
                        ¡Hola!,
                        {userData.givenName}
                        <br />
                      </>
                    )}
                  </Typography>
                </Grid>
                <Grid item>
                  <Button
                    id="Btn-cerrar-sesion-retos"
                    onClick={logOut}
                    variant="contained"
                    sx={{
                      color: colors.secondary,
                      "&:hover": {
                        backgroundColor: colors.secondary,
                      },
                    }}
                  >
                    Cerrar Sesión
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </StyledHeaderWrapper>

        {/* Menu Overlay */}
        <MenuOverlay isOpen={isMenuOpen}>
          <MenuContent isOpen={isMenuOpen}>
            {/* Header del menú */}
            <MenuHeader>
              <Typography
                variant="h6"
                sx={{
                  color: colors.primary,
                  fontWeight: 600,
                  fontSize: "1.2rem",
                }}
              >
                Retos Banco Industrial
              </Typography>

              <CloseButton onClick={toggleMenu}>
                <Close
                  sx={{
                    color: colors.primary,
                    fontSize: "2rem",
                  }}
                />
              </CloseButton>
            </MenuHeader>

            {/* Contenido del menú */}
            <MenuBody>
              <Grid container spacing={2} sx={{ width: "100%" }}>
                {/* Columna izquierda */}
                <Grid item xs={12} md={6}>
                  <MenuSection>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1.5rem",
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          color: colors.primary,
                          cursor: "pointer",
                          "&:hover": { opacity: 0.8 },
                          fontWeight: 700,
                        }}
                        onClick={() => navigate("/login")}
                      >
                        Iniciar Sesión
                      </Typography>
                      {/* <Typography
                        variant="h6"
                        sx={{
                          color: colors.primary,
                          cursor: "pointer",
                          "&:hover": { backgroundColor: colors.secondary },
                          fontWeight: 700,
                        }}
                      >
                        Retos y Premios
                      </Typography> */}
                      <Typography
                        variant="h6"
                        sx={{
                          color: colors.primary,
                          cursor: "pointer",
                          "&:hover": { opacity: 0.8 },
                          fontWeight: 700,
                        }}
                        onClick={() => {
                          window.open(
                            "https://www.corporacionbi.com/gt/bancoindustrial/crea-tu-cuenta-digital/",
                            "_blank",
                          );
                        }}
                      >
                        Abre tu cuenta Bi
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{
                          color: colors.primary,
                          cursor: "pointer",
                          "&:hover": { opacity: 0.8 },
                          fontWeight: 700,
                        }}
                        onClick={() => {
                          window.location.href = "/alfabetizacion-bancaria";
                        }}
                      >
                        Blog
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{
                          color: colors.primary,
                          cursor: "pointer",
                          "&:hover": { opacity: 0.8 },
                          fontWeight: 700,
                        }}
                        onClick={() => {
                          window.location.href = "/tester";
                        }}
                      >
                        Test Bienestar financiero
                      </Typography>
                    </div>

                    <div style={{ marginTop: "3rem" }}>
                      <Typography
                        variant="h6"
                        sx={{ color: colors.secondary, fontWeight: 600, mb: 2 }}
                      >
                        Descarga Bi en línea App
                      </Typography>
                      <AppStoreLinks>
                        <Link
                          onClick={() => {
                            window.location.href =
                              "https://apps.apple.com/gt/app/bi-en-l%C3%ADnea/id510761055";
                          }}
                        >
                          <SvgIcon
                            component={AppstoreLogo}
                            inheritViewBox
                            sx={{ width: "100px", color: "#000" }}
                          />
                        </Link>
                        <Link
                          onClick={() => {
                            window.location.href =
                              "https://play.google.com/store/apps/details?id=gt.com.bi.bienlinea&hl=es_GT&gl=US&pli=1";
                          }}
                        >
                          <SvgIcon
                            component={PlayStoreLogo}
                            inheritViewBox
                            sx={{ width: "100px", color: "#000" }}
                          />
                        </Link>
                      </AppStoreLinks>
                    </div>

                    {/* Links adicionales */}
                    <div
                      style={{
                        marginTop: "2rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: colors.secondary,
                          cursor: "pointer",
                          "&:hover": { opacity: 0.8 },
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          window.open(
                            "https://www.corporacionbi.com/gt/bancoindustrial/productos-bi/retos-bi#comofunciona",
                            "_blank",
                          );
                        }}
                      >
                        ¿Cómo funciona?
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: colors.secondary,
                          cursor: "pointer",
                          "&:hover": { opacity: 0.8 },
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          window.location.href = "mailto:retosbi@bi.com.gt";
                        }}
                      >
                        Ayuda o contacto
                      </Typography>
                    </div>

                    {/* Redes sociales */}
                    <div
                      style={{
                        marginTop: "2rem",
                        display: "flex",
                        gap: "1rem",
                      }}
                    >
                      <Facebook
                        sx={{
                          color: colors.secondary,
                          fontSize: "1.5rem",
                          cursor: "pointer",
                          "&:hover": { opacity: 0.8 },
                          fontWeight: 700,
                        }}
                        onClick={() => {
                          window.open(
                            "https://www.facebook.com/share/19aGpoesYb/?mibextid=wwXIfr",
                            "_blank"
                          );
                        }}
                      />
                      <SvgIcon
                        component={linkedinLogo}
                        inheritViewBox
                        sx={{
                          mt: "0.5rem",
                          fontSize: "2rem",
                          "& path": {
                            fill: colors.secondary,
                          },
                        }}
                        onClick={() => {
                          window.open(
                            "https://www.linkedin.com/company/bancoindustrial/",
                            "_blank",
                          );
                        }}
                      />
                      <SvgIcon
                        component={XLogo}
                        inheritViewBox
                        sx={{
                          mt: "0.5rem",
                          fontSize: "2rem",
                          "& path": {
                            fill: colors.secondary,
                          },
                          "&:hover": { opacity: 0.8 },
                        }}
                        onClick={() => {
                          window.open(
                            "https://x.com/bancoindustrial?s=11",
                            "_blank",
                          );
                        }}
                      />
                    </div>
                  </MenuSection>
                </Grid>

                {/* Columna derecha */}
                <Grid item xs={12} md={6}>
                  <MenuSection>
                    <Typography
                      variant="h6"
                      sx={{
                        color: colors.primary,
                        fontWeight: 600,
                        mb: 3,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        window.location.href = "mailto:retosbi@bi.com.gt";
                      }}
                    >
                      Ayuda o contacto
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        marginBottom: "1rem",
                      }}
                    >
                      <Phone
                        sx={{ color: colors.secondary, fontSize: "1.2rem" }}
                      />
                      <Typography
                        variant="body1"
                        sx={{ color: colors.primary }}
                        onClick={() => {
                          window.open("tel:+50224116000", "_self");
                        }}
                      >
                        +502 2411-6000
                      </Typography>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <Email
                        sx={{ color: colors.secondary, fontSize: "1.2rem" }}
                      />
                      <Typography
                        variant="body1"
                        sx={{ color: colors.primary, cursor: "pointer" }}
                        onClick={() => {
                          window.location.href = "mailto:retosbi@bi.com.gt";
                        }}
                      >
                        retosbi@bi.com.gt
                      </Typography>
                    </div>

                    <Typography
                      variant="h6"
                      sx={{
                        color: colors.primary,
                        fontWeight: 600,
                        mb: 3,
                        mt: 3,
                      }}
                    >
                      Temas que podrían interesarte
                    </Typography>
                    <WordPressFeaturedPosts />
                  </MenuSection>
                </Grid>
              </Grid>
            </MenuBody>
          </MenuContent>
        </MenuOverlay>
      </>
    );
  }

  // Versión default (sin login)
  return (
    <>
      <StyledHeaderWrapper isDefault>
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
          style={{ height: "100%", width: "95%", margin: "0 auto" }}
        >
          <Grid item sx={{ display: { xs: "none", sm: "block" } }}>
            <Typography
              variant="h6"
              sx={{
                color: colors.white.main,
                fontWeight: 600,
                fontSize: "1.2rem",
              }}
            >
              Retos Banco Industrial
            </Typography>
          </Grid>

          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Button
                  variant="text"
                  sx={{
                    backgroundColor: {
                      xs: colors.secondary,
                      md: "transparent",
                    },
                    color: { xs: colors.primary, md: colors.secondary },
                    textTransform: "none",
                    fontSize: "1rem",
                    "&:hover": {
                      backgroundColor: colors.secondary,
                    },
                    marginLeft: { xs: "5rem" },
                    marginRight: { xs: "1rem" },
                  }}
                  onClick={() => navigate("/login")}
                >
                  Iniciar Sesión
                </Button>
              </Grid>
              <Grid item>
                <MenuButton onClick={toggleMenu} isOpen={isMenuOpen}>
                  <span></span>
                  <span></span>
                  <span></span>
                </MenuButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{ display: { xs: "block", sm: "none", md: "none" } }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: colors.white.main,
                fontSize: { xs: "20px", md: "38px" },
                marginTop: "1rem",
                marginBottom: "0rem",
                textAlign: "center",
              }}
            >
              Retos Banco Industrial
            </Typography>
          </Grid>
        </Grid>
      </StyledHeaderWrapper>

      {/* Menu Overlay */}
      <MenuOverlay isOpen={isMenuOpen}>
        <MenuContent isOpen={isMenuOpen}>
          {/* Header del menú */}
          <MenuHeader>
            <Typography
              variant="h6"
              sx={{
                color: colors.primary,
                fontWeight: 600,
                fontSize: "1.2rem",
              }}
            >
              Retos Banco Industrial
            </Typography>

            <CloseButton onClick={toggleMenu}>
              <Close
                sx={{
                  color: colors.primary,
                  fontSize: "2rem",
                }}
              />
            </CloseButton>
          </MenuHeader>

          {/* Contenido del menú */}
          <MenuBody>
            <Grid container spacing={2} sx={{ width: "100%" }}>
              {/* Columna izquierda */}
              <Grid item xs={12} md={6}>
                <MenuSection>
                  <LinkContainer
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1.5rem",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: colors.primary,
                        cursor: "pointer",
                        "&:hover": { opacity: 0.8 },
                        fontWeight: 700,
                      }}
                      onClick={() => navigate("/login")}
                    >
                      Iniciar Sesión
                    </Typography>
                    {/* <Typography
                      variant="h6"
                      sx={{
                        color: colors.primary,
                        cursor: "pointer",
                        "&:hover": { opacity: 0.8 },
                        fontWeight: 700,
                      }}
                    >
                      Retos y Premios
                    </Typography> */}
                    <Typography
                      variant="h6"
                      sx={{
                        color: colors.primary,
                        cursor: "pointer",
                        "&:hover": { opacity: 0.8 },
                        fontWeight: 700,
                      }}
                      onClick={() => {
                        window.open(
                          "https://www.corporacionbi.com/gt/bancoindustrial/crea-tu-cuenta-digital/",
                          "_blank",
                        );
                      }}
                    >
                      Abre tu cuenta Bi
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        color: colors.primary,
                        cursor: "pointer",
                        "&:hover": { opacity: 0.8 },
                        fontWeight: 700,
                      }}
                      onClick={() => {
                        window.location.href = "/alfabetizacion-bancaria";
                      }}
                    >
                      Blog
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        color: colors.primary,
                        cursor: "pointer",
                        "&:hover": { opacity: 0.8 },
                        fontWeight: 700,
                        display: { xs: "none", md: "block" },
                      }}
                      onClick={() => {
                        window.location.href = "/tester";
                      }}
                    >
                      Test Bienestar financiero
                    </Typography>
                  </LinkContainer>

                  {/* Descarga App */}
                  <div style={{ marginTop: "3rem" }}>
                    <Typography
                      variant="h6"
                      sx={{
                        color: colors.secondary,
                        fontWeight: 600,
                        mb: 2,
                        display: { xs: "none", md: "block" },
                      }}
                    >
                      Descarga Bi en línea App
                    </Typography>
                    <AppStoreLinks>
                      <Link
                        onClick={() => {
                          window.open(
                            "https://apps.apple.com/gt/app/bi-en-l%C3%ADnea/id510761055",
                            "_blank",
                          );
                        }}
                      >
                        <SvgIcon
                          component={AppstoreLogo}
                          inheritViewBox
                          sx={{
                            width: { xs: "160px", md: "100px" },
                            height: { xs: "40px", md: "40px" },
                            color: "#000",
                          }}
                        />
                      </Link>
                      <Link
                        onClick={() => {
                          window.location.href =
                            "https://play.google.com/store/apps/details?id=gt.com.bi.bienlinea&hl=es_GT&gl=US&pli=1";
                        }}
                      >
                        <SvgIcon
                          component={PlayStoreLogo}
                          inheritViewBox
                          sx={{
                            width: { xs: "160px", md: "100px" },
                            height: { xs: "40px", md: "40px" },
                            color: "#000",
                          }}
                        />
                      </Link>
                    </AppStoreLinks>
                  </div>

                  {/* Links adicionales */}
                  <AdditionalLinks
                    style={{
                      marginTop: "2rem",
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: colors.secondary,
                        cursor: "pointer",
                        "&:hover": { opacity: 0.8 },
                        fontSize: "14px",
                      }}
                      onClick={() => {
                        window.open(
                          "https://www.corporacionbi.com/gt/bancoindustrial/productos-bi/retos-bi#comofunciona",
                          "_blank",
                        );
                      }}
                    >
                      ¿Cómo funciona?
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: colors.secondary,
                        cursor: "pointer",
                        "&:hover": { opacity: 0.8 },
                        fontSize: "14px",
                      }}
                      onClick={() => {
                        window.location.href = "mailto:retosbi@bi.com.gt";
                      }}
                    >
                      Ayuda o contacto
                    </Typography>
                  </AdditionalLinks>

                  {/* Redes sociales */}
                  <div
                    style={{ marginTop: "2rem", display: "flex", gap: "1rem" }}
                  >
                    <Facebook
                      sx={{
                        color: colors.secondary,
                        fontSize: "3rem",
                        cursor: "pointer",
                        "&:hover": { opacity: 0.8 },
                        fontWeight: 700,
                      }}
                    />
                    <SvgIcon
                      component={linkedinLogo}
                      inheritViewBox
                      sx={{
                        mt: "0.5rem",
                        fontSize: "2rem",
                        "& path": {
                          fill: colors.secondary,
                        },
                      }}
                      onClick={() => {
                        window.open(
                          "https://www.linkedin.com/company/bancoindustrial/",
                          "_blank",
                        );
                      }}
                    />
                    <SvgIcon
                      component={XLogo}
                      inheritViewBox
                      sx={{
                        mt: "0.5rem",
                        fontSize: "2rem",
                        "& path": {
                          fill: colors.secondary,
                        },
                        "&:hover": { opacity: 0.8 },
                      }}
                      onClick={() => {
                        window.open(
                          "https://x.com/bancoindustrial?s=11",
                          "_blank",
                        );
                      }}
                    />
                  </div>
                </MenuSection>
              </Grid>

              {/* Columna derecha */}
              <Grid
                item
                xs={12}
                md={6}
                sx={{ display: { xs: "none", md: "block" } }}
              >
                <MenuSection>
                  <Typography
                    variant="h6"
                    sx={{
                      color: colors.primary,
                      fontWeight: 600,
                      mb: 3,
                      display: { xs: "none", md: "block" },
                    }}
                    onClick={() => {
                      window.location.href = "mailto:retosbi@bi.com.gt";
                    }}
                  >
                    Ayuda o contacto
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      marginBottom: "1rem",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        color: colors.secondary,
                        fontWeight: 700,
                        display: { xs: "none", md: "block" },
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        window.open("tel:+50224116000", "_self");
                      }}
                    >
                      +502 2411-6000
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        color: colors.secondary,
                        fontWeight: 700,
                        display: { xs: "none", md: "block" },
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        window.location.href = "mailto:retosbi@bi.com.gt";
                      }}
                    >
                      retosbi@bi.com.gt
                    </Typography>
                  </div>

                  <Typography
                    variant="h6"
                    sx={{
                      color: colors.primary,
                      fontWeight: 600,
                      mb: 3,
                      mt: 3,
                      display: { xs: "none", md: "block" },
                    }}
                  >
                    Temas que podrían interesarte
                  </Typography>
                  <WordPressFeaturedPosts />
                </MenuSection>
              </Grid>
            </Grid>
          </MenuBody>
        </MenuContent>
      </MenuOverlay>
    </>
  );
}
